<template>
  <div>
    <AlerteEspaceMembre />
    <div class="text-center my-2 my-sm-6 my-md-12">
      <LinkLogo class="mx-auto" />
    </div>
    <v-sheet class="d-flex justify-space-between mx-auto mb-2 align-center" max-width="800">
      <ChangeLocale />
      <div>
        <router-link
          :to="{ name: 'FormulaireDonInHonoriam', query: this.$route.query }"
          v-show="!inHonoriam"
          class="mr-2"
          >{{ $t("formulaireDon.donInHonoriam") }}</router-link
        >
        <router-link
          :to="{ name: 'FormulaireDonInMemoriam', query: this.$route.query }"
          v-show="!inMemoriam"
          class="mr-2"
          >{{ $t("formulaireDon.donInMemoriam") }}</router-link
        >
        <router-link :to="{ name: 'FormulaireDon', query: this.$route.query }" v-show="dedicace">{{
          $t("formulaireDon.donEnLigne")
        }}</router-link>
      </div>
    </v-sheet>
    <v-sheet max-width="800" class="py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12 mx-auto mb-6" id="bordered-sheet">
      <v-sheet max-width="500" class="mx-auto">
        <h1 class="display-2">{{ $t(titleKey) }}</h1>

        <v-divider class="mt-2 mb-4"></v-divider>
        <Account class="mb-6" />
        <v-form ref="formulaireDon" :disabled="loading" lazy-validation>
          <h2 class="mb-2">{{ $t("formulaireDon.contribution") }}</h2>
          <SelectionType :types="types" v-model="typeDeDon" v-if="!dedicace" :disabled="loading" />
          <div v-if="typeDeDon === 'unique'">
            <SelectionMontant :montants="[25, 50, 75]" v-model="montantDonUnique" :disabled="loading" />
          </div>
          <div v-if="typeDeDon === 'mensuel'">
            <p class="font-italic">
              <v-img src="@/assets/logoMensuel.jpg" max-width="100" max-height="100"></v-img
              >{{ $t("formulaireDon.detailPrelevement") }}
            </p>
            <SelectionMontant :montants="[10, 15, 25]" v-model="montantDonMensuel" :disabled="loading" />
          </div>

          <h2 class="mb-2">{{ $t("formulaireDon.donateur") }}</h2>

          <LoadingComponent :loading="loadingCatalogues">
            <v-radio-group row v-model="civilite" :rules="required">
              <v-radio v-for="civilite in catalogues.civilites" :key="civilite.id" :value="civilite.id">
                <template v-slot:label>{{ civilite[$i18n.locale] }}</template>
              </v-radio>
            </v-radio-group>
          </LoadingComponent>

          <v-text-field
            v-model="courriel"
            outlined
            :rules="requiredEmail"
            id="courriel"
            :disabled="authMethod === 'TokenExtranetX'"
          >
            <template v-slot:label>{{ $t("infosPersonnelles.courriel") }} *</template>
          </v-text-field>
          <v-text-field v-model="prenom" outlined :rules="required" id="prenom">
            <template v-slot:label>{{ $t("infosPersonnelles.prenom") }} *</template>
          </v-text-field>
          <v-text-field v-model="nom" outlined :rules="required" id="nom">
            <template v-slot:label>{{ $t("infosPersonnelles.nom") }} *</template>
          </v-text-field>
          <v-select v-model="anneeNaissance" outlined :items="anneesDeNaissance">
            <template v-slot:label>{{ $t("infosPersonnelles.anneeNaissance") }}</template>
          </v-select>
          <v-checkbox v-model="isCorporatif" class="mt-0">
            <template v-slot:label>{{ $t("formulaireDon.donCorporatif") }}</template>
          </v-checkbox>
          <v-text-field v-model="societe" outlined v-if="isCorporatif" :rules="required" id="societe">
            <template v-slot:label>{{ $t("formulaireDon.societe") }} *</template>
          </v-text-field>

          <h2 class="mb-2">{{ $t("formulaireDon.adresse") }}</h2>
          <v-text-field v-model="adresse" outlined :rules="required" id="adresse-field" ref="adresse-field">
            <template v-slot:label>{{ $t("adresse.adresse") }} *</template>
          </v-text-field>
          <v-text-field v-model="ville" outlined :rules="required" id="ville">
            <template v-slot:label>{{ $t("adresse.ville") }} *</template>
          </v-text-field>
          <v-text-field v-model="codePostal" outlined v-facade="'A#A #A#'" :rules="codePostalRules" id="code-postal">
            <template v-slot:label>{{ $t("adresse.codePostal") }} *</template>
          </v-text-field>

          <LoadingComponent :loading="loadingCatalogues">
            <v-autocomplete
              :items="catalogues.provinces"
              v-model="province"
              outlined
              :item-text="$i18n.locale"
              item-value="id"
              :rules="required"
            >
              <template v-slot:label>{{ $t("adresse.province") }} *</template>
            </v-autocomplete>
          </LoadingComponent>
          <v-text-field v-model="telephone" outlined v-facade="'(###) ### ####'" :rules="phoneRules" id="telephone">
            <template v-slot:label>{{ $t("adresse.telephone") }} *</template>
          </v-text-field>
          <v-text-field
            v-model="telephoneAuTravail"
            outlined
            v-facade="'(###) ### ####'"
            :rules="optionalPhoneRules"
            id="telephone-travail"
          >
            <template v-slot:label>{{ $t("adresse.telephoneAuTravail") }}</template>
          </v-text-field>

          <template v-if="dedicace">
            <h2 class="mb-2">{{ $t(dedicaceKey) }}</h2>
            <v-text-field v-model="honoreDedicace" outlined :rules="required" id="honore-dedicace">
              <template v-slot:label>{{ $t(dedicaceKey) }} *</template>
            </v-text-field>
            <h2 class="mb-2">{{ $t("dedicace.famille") }}</h2>
            <v-text-field v-model="prenomDedicace" outlined :rules="required" id="prenom-dedicace">
              <template v-slot:label>{{ $t("dedicace.prenom") }} *</template>
            </v-text-field>
            <v-text-field v-model="nomDedicace" outlined :rules="required" id="nom-dedicace">
              <template v-slot:label>{{ $t("dedicace.nom") }} *</template>
            </v-text-field>
            <v-text-field v-model="adresseDedicace" outlined id="dedidace-adresse-field" ref="dedidace-adresse-field">
              <template v-slot:label>{{ $t("dedicace.adresse") }}</template>
            </v-text-field>
            <v-text-field v-model="villeDedicace" outlined id="ville-dedicace">
              <template v-slot:label>{{ $t("dedicace.ville") }}</template>
            </v-text-field>
            <v-text-field v-model="codePostalDedicace" outlined v-facade="'A#A #A#'" id="code-postal-dedicace">
              <template v-slot:label>{{ $t("dedicace.codePostal") }}</template>
            </v-text-field>
            <LoadingComponent :loading="loadingCatalogues">
              <v-autocomplete
                :items="catalogues.provinces"
                v-model="provinceDedicace"
                outlined
                :item-text="$i18n.locale"
                item-value="id"
              >
                <template v-slot:label>{{ $t("dedicace.province") }}</template>
              </v-autocomplete>
            </LoadingComponent>
            <v-checkbox v-model="consentementDedicace">
              <template v-slot:label>{{ $t(consentementKey) }}</template>
            </v-checkbox>
          </template>

          <h2 class="mb-2">{{ $t("formulaireDon.source") }}</h2>

          <LoadingComponent :loading="loadingCatalogues">
            <div v-for="(sourceItem, index) in catalogues.donSources" :key="sourceItem.id">              
              <v-checkbox
                :value="sourceItem.id"
                v-model="source" class="mt-0"
                :rules="requiredMultiple"
                :hide-details="index !== catalogues.donSources.length - 1"
              >
                <template v-slot:label>{{ sourceItem[$i18n.locale] }}</template>
              </v-checkbox>
            </div>
          </LoadingComponent>
        </v-form>

        <v-btn block color="primary" large @click="payNow" :disabled="loading" :loading="loading">{{
          $t("formulaireDon.boutonPaiement")
        }}</v-btn>
        <p class="caption mt-6 font-italic">
          {{ $t("formulaireDon.numeroFondation") }}
        </p>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import LinkLogo from "@/components/common/LinkLogo"
import Account from "@/components/common/Account.vue"
import SelectionMontant from "@/components/common/SelectionMontant.vue"
import SelectionType from "@/components/common/SelectionType.vue"
import ChangeLocale from "@/components/common/ChangeLocale"
import LoadingComponent from "@/components/common/LoadingComponent"
import AlerteEspaceMembre from "@/components/common/AlerteEspaceMembre"

import CataloguesLoader from "@/mixins/CataloguesLoader"
import PosteCanada from "@/mixins/PosteCanada"
import AdresseDedicaceModel from "@/mixins/AdresseDedicaceModel"
import InfosPersonnellesModel from "@/mixins/InfosPersonnellesModel"
import PaysafeModale from "@/mixins/PaysafeModale"

import Rules from "@/mixins/Rules"
import Auth from "@/mixins/Auth"
import { Api } from "@/plugins/api"
import { mapGetters } from "vuex"
export default {
  mixins: [CataloguesLoader, PosteCanada, InfosPersonnellesModel, AdresseDedicaceModel, Rules, PaysafeModale, Auth],
  data() {
    return {
      cataloguesToLoad: ["civilites", "provinces", "donSources"],
      montantDonUnique: 25,
      montantDonMensuel: 10,
      typeDeDon: "unique",
      isCorporatif: false,
      societe: "",
      source: [],
      loading: false,
      additionalPosteCanadaConfigs: [
        {
          searchFieldId: "dedidace-adresse-field",
          adresseKey: "adresseDedicace",
          villeKey: "villeDedicace",
          codePostalKey: "codePostalDedicace",
          provinceKey: "provinceDedicace",
        },
      ],
    }
  },

  methods: {
    payNow() {
      if (!this.$refs.formulaireDon.validate()) {
        return
      }
      this.loading = true
      const montant = this.typeDeDon === "unique" ? this.montantDonUnique : this.montantDonMensuel
      this.showPaysafeModale(montant, `${this.prenom} ${this.nom}`)
    },

    onSuccessPaysafe(token) {
      this.loading = true
      let payload = {
        adresse: this.adresse,
        adresseDedicace: this.adresseDedicace,
        civilite: this.civilite,
        codePostal: this.codePostal,
        codePostalDedicace: this.codePostalDedicace,
        courriel: this.courriel,
        honoreDedicace: this.honoreDedicace,
        isCorporatif: this.isCorporatif,
        montant: this.typeDeDon === "unique" ? this.montantDonUnique : this.montantDonMensuel,
        nom: this.nom,
        nomDedicace: this.nomDedicace,
        prenom: this.prenom,
        prenomDedicace: this.prenomDedicace,
        province: this.province,
        provinceDedicace: this.provinceDedicace,
        societe: this.societe,
        telephone: this.telephone,
        telephoneAuTravail: this.telephoneAuTravail,
        typeDeDon: this.typeDeDon,
        ville: this.ville,
        villeDedicace: this.villeDedicace,
        typeDeDedicace: this.typeDeDedicace,
        paymentToken: token,
        langue: this.$i18n.locale,
        anneeNaissance: this.anneeNaissance,
        consentementDedicace: this.consentementDedicace,
        source: this.source
      }
      Api.post("/donations", payload)
        .then((res) => {
          const paiementReussi = res.data.paiementReussi
          if (paiementReussi) {
            if (this.typeDeDon === "mensuel") {
              this.$router.push({ name: "RemerciementDonMensuel", query: this.$route.query })
            } else {
              this.$router.push({ name: "RemerciementDon", query: this.$route.query })
            }
          } else {
            this.$router.push({ name: "ErreurPaiement", query: this.$route.query })
          }
        })
        .catch(() => {
          this.$router.push({ name: "ErreurPaiement", query: this.$route.query })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCloseBeforePayment() {
      this.loading = false
    },
  },
  computed: {
    ...mapGetters(["catalogues", "authMethod"]),
    types() {
      return [
        { id: "unique", text: this.$t("formulaireDon.unique") },
        { id: "mensuel", text: this.$t("formulaireDon.mensuel") },
      ]
    },
    inHonoriam() {
      return this.$route.name === "FormulaireDonInHonoriam"
    },
    inMemoriam() {
      return this.$route.name === "FormulaireDonInMemoriam"
    },
    dedicace() {
      return this.inMemoriam || this.inHonoriam
    },
    titleKey() {
      if (this.inHonoriam) {
        return "formulaireDon.donInHonoriam"
      } else if (this.inMemoriam) {
        return "formulaireDon.donInMemoriam"
      }
      return "formulaireDon.donEnLigne"
    },
    consentementKey() {
      if (this.inHonoriam) {
        return "dedicace.consentementHonoriam"
      } else if (this.inMemoriam) {
        return "dedicace.consentementMemoriam"
      }
      return ""
    },
    typeDeDedicace() {
      if (this.inHonoriam) {
        return "DonInHonoriam"
      } else if (this.inMemoriam) {
        return "DonInMemoriam"
      }
      return "Don"
    },
    dedicaceKey() {
      if (this.inHonoriam) {
        return "formulaireDon.occasionDe"
      } else if (this.inMemoriam) {
        return "formulaireDon.memoireDe"
      }
    },
  },
  components: {
    LinkLogo,
    Account,
    SelectionMontant,
    SelectionType,
    ChangeLocale,
    LoadingComponent,
    AlerteEspaceMembre,
  },
  mounted() {
    this.$i18n.locale = this.$route.query.lang || "fr"
    this.loginWithToken()
  },
}
</script>

<style></style>
